import { MaterialModule } from './../../modules/material/material.module';
import { NgModule } from '@angular/core';
import { IFFormBlockComponent } from './if-form-block.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { GeoService } from 'src/app/services/geo.service';

@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [
    IFFormBlockComponent
  ],
  exports: [
    IFFormBlockComponent
  ],
  providers: [
    GeoService
  ]
})
export class IFFormBlockModule { }
